import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { api } from '../api';
import BackButton from '../components/BackButton';
import styles from './Auth.module.css';

export function VerifyEmail() {
  const location = useLocation();
  const token = new URLSearchParams(location.search).get('token');
  const [status, setStatus] = useState('verifying'); // verifying | success | error

  useEffect(() => {
    if (!token) { setStatus('error'); return; }
    api.verifyEmail(token)
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, [token]);

  return (
    <div className={styles.page}>
      <BackButton />
      <div className={styles.card}>
        {status === 'verifying' && (
          <>
            <div className="spinner" style={{ margin: '0 auto' }} />
            <p style={{ textAlign: 'center', color: 'var(--gray)', marginTop: 16 }}>Verifying your email…</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className={styles.successIcon}>✅</div>
            <h2 className={styles.title}>Email verified!</h2>
            <p className={styles.sub}>Your account is active. You can now log in and start voting.</p>
            <Link to="/login" className="btn btn-magenta" style={{ display: 'inline-flex', marginTop: 16 }}>
              Log In
            </Link>
          </>
        )}
        {status === 'error' && (
          <>
            <div className={styles.successIcon}>❌</div>
            <h2 className={styles.title}>Link invalid or expired</h2>
            <p className={styles.sub}>
              This verification link has expired or already been used.
              Try registering again or contact support.
            </p>
            <Link to="/register" className="btn btn-outline-magenta" style={{ display: 'inline-flex', marginTop: 16 }}>
              Register Again
            </Link>
          </>
        )}
      </div>
    </div>
  );
}

export default VerifyEmail;
